import React, { useState, useContext, useRef, useEffect } from "react";
import { Card, Select, SelectOption, Label, Icon, TabRoot, TabList, TabTrigger, TabContent, Breadcrumb, BreadcrumbLink, Button, Sidebar as SidebarNYX, Tooltip } from "@pmi/nyx-design-system";
import PerformanceCard from "./performancecard";
import DensityCoverage from "./densitycoverage";
import flag from '../../assets/images/flag.png';
import { SidebarContext } from "../../context/sidebarcontext";
import { FiltersContext } from "../../context/filterscontext";
import MarketModel from "./marketmodel";
import { MapviewContext } from "../../context/mapviewcontext";
import { ApiContext } from "../../context/apicontext";

// Left sidebar code
function Sidebar() {
    const { selectedIndicator, setSelectedIndicator} = useContext(SidebarContext);
    const {benchmarkData, leftdemographicsData, rightdemographicsData} = useContext(ApiContext);
    const [selectedValue, setSelectedValue] = useState("");
    const cardRef = useRef(null);
    const { handleData, setShowFilters,showFilters } = useContext(FiltersContext);
    const { selectedRegion, setSelectedPlace, selectedTerritory, setSelectedTerritory,setSelectedRegion} = useContext(MapviewContext);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOptions = (value) => {
        const selectedOption = benchmarkData?.leftOptions?.find(option => option.value === value);
        if (selectedOption) {
            setSelectedValue(selectedOption?.text || "");
        }
    };
    // Set first option as default
    useEffect(() => {
        if (benchmarkData?.leftOptions?.length > 0) {
            setSelectedValue(benchmarkData.leftOptions[0].text);
        }
    }, [benchmarkData]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cardRef.current && !cardRef.current.contains(event.target)) {
                setSelectedIndicator(null);
            }
        };

        if (selectedIndicator) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [selectedIndicator]);

    const handleBackTo = (place) => {
        if (place === 'country') {
            setSelectedRegion('');
            setSelectedTerritory('');
            setSelectedPlace('');
            setShowFilters(false);
        } else {
            setSelectedTerritory('');
            setSelectedPlace('');
            setShowFilters(false);
        }
        // if (storePlaceHistory.length >= 0) {
        //     const previousPlaces = [...storePlaceHistory];
        //     const lastPlace = previousPlaces.pop();
        //     setSelectedPlace(lastPlace);
        //     setStorePlaceHistory(previousPlaces);
        //     if (previousPlaces.length === 0) {
        //         setSelectedTerritory("")
        //         setBreadcrumbData([]);
        //         currentPolygonRef.current = null;
        //         setShowFilters(false);
        //     }
        // }
    };

    useEffect(() => {

    }, [handleData, selectedRegion])

    // useEffect(() => {
    //     if (selectedTerritory === "" && leftdemographicsData?.Consumables?.length) {
    //         setSelectedIndicator(leftdemographicsData.Consumables[0].indicator);
    //     }
    // }, [leftdemographicsData]);
    
    return (
        <>
            <SidebarNYX>
                <div className="w-100">
                    <div className="sidebar-title p-4">
                        {!!selectedRegion ?
                            <div>
                                <Breadcrumb>
                                    {selectedRegion &&
                                        <>
                                            <BreadcrumbLink color="primary" onClick={() => { handleBackTo('country') }}>Czech republic</BreadcrumbLink>
                                            <BreadcrumbLink onClick={() => { handleBackTo('region') }}>{selectedRegion}</BreadcrumbLink>
                                        </>
                                    }
                                    {selectedTerritory &&
                                        <BreadcrumbLink>{selectedTerritory}</BreadcrumbLink>
                                    }
                                    {/* {storePlaceHistory?.length > 3 ? (
                                        <>
                                            <BreadcrumbLink color="primary">{storePlaceHistory[0]}</BreadcrumbLink>
                                            <span>...</span>
                                            <BreadcrumbLink color="primary">{storePlaceHistory[storePlaceHistory.length - 1]}</BreadcrumbLink>
                                        </>
                                    ) : (
                                        storePlaceHistory?.map((place, index) => (
                                            <BreadcrumbLink key={index} color="primary" selected={index === storePlaceHistory.length - 1}>
                                                {place}
                                            </BreadcrumbLink>
                                        ))
                                    )} */}
                                </Breadcrumb>
                                <div className="d-flex pt-3">
                                    <Icon color="dark" size='large' data-testid="icon-test" name="arrow-left" onClick={() => { handleBackTo(selectedTerritory ? 'region' : 'country') }} />
                                    <Label className="label">{selectedTerritory ? selectedTerritory : selectedRegion}</Label>
                                </div>
                            </div>
                            :
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div className="d-flex align-items-center">
                                    <img src={flag} height={36} alt="flag"></img>
                                    <h5 className="fw-bold ms-2">Czech Republic</h5>
                                </div>
                                <Button outlined onClick={() => setIsModalOpen(true)}>Change Market<Icon name="selector" color="primary" className="mt-1" /> </Button>
                                {isModalOpen && <MarketModel onClose={() => setIsModalOpen(false)} />}
                            </div>
                        }
                        <Card icon="alert-circle" className="lastdata-alert" orientation="horizontal">
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <span>Last data received from market:</span>
                                <span className="font-medium">Q4 2024</span>
                            </div>
                            <a href="#" className="text-blue-600 text-sm mt-1 block">See details</a>
                        </Card>
                    </div>
                    <div className="sidebar-inner">
                        <div className="benchmark-column p-3 pe-3 pb-0 mb-2">
                            <div className="d-flex alim-align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className="d-flex bg-lightgray p-1 rounded-3 me-1">
                                        <Icon color="dark" size='small' data-testid="icon-test" name="clipboard-list" />
                                    </div>
                                    <h6 className="small fw-bold">Benchmark column</h6>
                                </div>
                                <Select className="dropdown-box custom-dropdown" starticon="download" endicon="chevron-down" placeholder={selectedValue} size="small" onChange={(value) => handleOptions(value)} >
                                    {benchmarkData?.leftOptions?.map((option, index) => (
                                        <SelectOption key={index} value={option.value}>
                                            {option.text}
                                        </SelectOption>
                                    ))}
                                </Select>
                            </div>
                            <div className="divider-gray mt-4"></div>
                        </div>

                        {/* Demographics Data */}
                        <div className="accordion ps-4 pe-3" id="demographicsAccordion">
                            <div className="accordion-item">
                                <h2 className="accordion-header py-2" id="headingOne">
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse"
                                        aria-expanded="true"
                                        aria-controls="collapse"
                                    >
                                        Demographics
                                    </button>
                                </h2>
                                <div
                                    id="collapse"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#demographicsAccordion"
                                >
                                    <div className="accordion-body">
                                        <div className="demographics-data small px-2">
                                            <Label className="d-flex align-items-center text-transform-none fw-bold small"><Icon color="dark" data-testid="icon-test" name="map-2" size="small" className="me-2" />Indicator</Label>
                                            <Label className="text-transform-none fw-bold small">Actual</Label>
                                            <Label className="d-flex align-items-center fw-bold small"><div className="d-flex bg-lightgray p-1 rounded-3 me-1"><Icon color="dark" data-testid="icon-test" name="clipboard-list" size="small" /></div>Benchmark</Label>
                                        </div>
                                        {((selectedTerritory === "" ? leftdemographicsData?.Demographics :
                                            (handleData ? rightdemographicsData?.Demographics : leftdemographicsData?.Demographics))?.map((row, index) => (
                                                <div key={index} className="tab-data px-2">
                                                    <div className="d-flex align-items-center">
                                                        <Icon color="#E0E0E0" data-testid="icon-test" name="eye-filled" size="small" className="me-2" />
                                                        <Label className="text-transform-none">{row.indicator}</Label>
                                                    </div>
                                                    <span className="text-transform-none">{row.actual}</span>
                                                    {(selectedTerritory === "" || !handleData) ? <span className={(row.benchmark === 'N/A' || row.benchmark === 'No data' ? "benchmark-na justify-content-center" : row.benchmark > 0.6 ? "benchmark-up" : "benchmark-down") + " text-transform-none d-flex align-items-center ms-4"}>
                                                        {row.benchmark === 'N/A' || row.benchmark === 'No data' ? '' : row.benchmark > 0.6 ?
                                                            <Icon color="#2D8121" data-testid="icon-test" name="arrow-up" size="medium" /> :
                                                            <Icon color="#d23f32" data-testid="icon-test" name="arrow-down" size="medium" />
                                                        }
                                                        {row.benchmark}
                                                        {row.benchmark === 'N/A' || row.benchmark === 'No data' ? '' : '%'}
                                                    </span>
                                                        :
                                                        (<span className={(row.benchmark === 'N/A' || row.benchmark === 'No data' ? "text-muted" : "") + " text-transform-none d-flex align-items-center ms-4"}>
                                                            {row.benchmark}
                                                            {row.benchmark === 'N/A' || row.benchmark === 'No data' ? '' : '%'}
                                                        </span>)}

                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="ps-4 pe-3 pb-3">
                            {/* Performance Data */}
                            <div className="mb-3 mt-4">
                                <TabRoot defaultValue="tab1">
                                    <div className="tab-list">
                                        <TabList>
                                            <TabTrigger badgeColor="primary" badgeValue={0} value="tab1">
                                                Performance
                                            </TabTrigger>
                                            <TabTrigger value="tab2">
                                                Density & coverage
                                            </TabTrigger>
                                        </TabList>
                                    </div>

                                    <Label size="small" color="gray" className="text-transform-none text-muted py-1"><Icon color="dark" className="m-1 mb-2" data-testid="icon-test" name="alert-circle" size="small" />Monthly average</Label>
                                    {/* CONSUMABLES and KITS Data */}
                                    <TabContent value="tab1">
                                        <TabSection title="CONSUMABLES" data={{ left: leftdemographicsData?.Consumables, right: rightdemographicsData?.Consumables }}
                                            selectedIndicator={selectedIndicator} setSelectedIndicator={setSelectedIndicator}
                                            selectedTerritory={selectedTerritory} handleData={handleData} />

                                        <TabSection title="KITS" data={{ left: leftdemographicsData?.Kits, right: rightdemographicsData?.Kits }}
                                            selectedIndicator={selectedIndicator} setSelectedIndicator={setSelectedIndicator}
                                            selectedTerritory={selectedTerritory} handleData={handleData} />
                                    </TabContent>
                                    <TabContent value="tab2">
                                        <DensityCoverage />
                                    </TabContent>
                                </TabRoot>
                            </div>
                        </div>
                    </div>
                </div>
            </SidebarNYX>
            
            {selectedIndicator && (
                <div ref={cardRef}>
                    <PerformanceCard selectPerformanceData={selectedIndicator} />
                </div>
            )}
        </>
    )
}

export default Sidebar;

{/* CONSUMABLES and KITS Data */ }
const TabSection = ({ title, data, selectedIndicator, setSelectedIndicator, selectedTerritory, handleData }) => {
    return (
        <>
            <div className="py-3 fw-bold">{title}</div>
            <div className="tab-content small px-2">
                <Label className="d-flex align-items-center text-transform-none fw-bold small">
                    <Icon color="dark" data-testid="icon-test" name="map-2" size="small" className="me-2" />
                    Indicator
                </Label>
                <Label className="text-transform-none fw-bold small">Actual</Label>
                <Label className="d-flex align-items-center fw-bold small">
                    <div className="d-flex bg-lightgray p-1 rounded-3 me-1">
                        <Icon color="dark" data-testid="icon-test" name="clipboard-list" size="small" />
                    </div>
                    Benchmark
                </Label>
            </div>

            {(selectedTerritory === "" ? data?.left : (handleData ? data?.right : data?.left))?.map((row, index) => (
                <div key={index}>
                    <div
                        className="tab-data px-2"
                        onClick={() => setSelectedIndicator(row.indicator)}
                        style={{ backgroundColor: selectedIndicator === row.indicator ? "#DFF2FB" : "transparent" }}
                    >
                        <div className="d-flex align-items-center">
                            <Icon
                                color={selectedIndicator === row.indicator ? "primary" : "#E0E0E0"}
                                data-testid="icon-test"
                                name="eye-filled"
                                size="small"
                                className="me-2"
                            />
                            <Tooltip
                                align="center"
                                content={<div><strong>{row.indicator}</strong><br />Indicator description and how it is calculated</div>}
                                side="top"
                                trigger={<Label className="text-transform-none">{row.indicator}</Label>}
                            />
                        </div>
                        <span className="text-transform-none">{row.actual}</span>
                        {(selectedTerritory === "" || !handleData) ? (
                            <span className={(row.benchmark === 'N/A' || row.benchmark === 'No data' ? "benchmark-na justify-content-center" : row.benchmark > 0.6 ? "benchmark-up" : "benchmark-down") + " text-transform-none d-flex align-items-center ms-4"}>
                                {row.benchmark === 'N/A' || row.benchmark === 'No data' ? '' : row.benchmark > 0.6 ?
                                    <Icon color="#2D8121" data-testid="icon-test" name="arrow-up" size="medium" /> :
                                    <Icon color="#d23f32" data-testid="icon-test" name="arrow-down" size="medium" />
                                }
                                {row.benchmark}
                                {row.benchmark === 'N/A' || row.benchmark === 'No data' ? '' : '%'}
                            </span>
                        ) : (
                            <span className={(row.benchmark === 'N/A' || row.benchmark === 'No data' ? "text-muted" : "") + " text-transform-none d-flex align-items-center ms-4"}>
                                {row.benchmark}
                                {row.benchmark === 'N/A' || row.benchmark === 'No data' ? '' : '%'}
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </>
    );
};
